// extracted by mini-css-extract-plugin
module.exports = {"navigator":"style_navigator__2xxL_","logo":"style_logo__1sbmO","menu":"style_menu__AcN3I","active":"style_active__2nEc8"};